import React from 'react'
import usePersonalityHero from './hooks/usePersonalityHero'
import s from './styles/PersonalityHero.module.scss'
import LoaderImg from 'shared/components/LoaderImg/LoaderImg'

const PersonalityHero = ({ personality = null, isLoading = false }) => {
	const vm = usePersonalityHero(personality)
	return (
		<section
			className={[s.hero, isLoading && s.loading].filter(Boolean).join(' ')}
			aria-label="Primary personality archetype"
		>
			<p className={s.subtitle}> Primary Archetype</p>
			<h3 className={s.title}>
				{isLoading ? <LoaderImg /> : vm?.title && vm.title}
			</h3>
			<p className={s.description}>
				{isLoading ? <LoaderImg /> : vm?.description && vm.description}
			</p>
			<div className={s.tags}>
				{(isLoading ? [...Array(4)].map((_, i) => i + 1) : vm?.tags || []).map(
					tag => (
						<span key={tag} className={s.tag}>
							{isLoading ? <LoaderImg /> : tag}
						</span>
					),
				)}
			</div>
		</section>
	)
}

export default PersonalityHero
